import config from "../Context/Config";
import { handleApiError } from "./error";

export const updateCode = async (code, apptId, tryRefresh,form) => {
    try {
        const response = await fetch(`${config.API_BASE_URL}/check_and_update`, {
            method: "POST",
            headers: {
                "action_id": config.ACTIONID["edit"],
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("digital-form-idtoken"),
                "practice": localStorage.getItem("digital-form-dept-practice")
            },
            body: JSON.stringify({
                apptId,
                form: form,
                code,
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data !== "code not found";
        }

        // Handle errors like 401, 403, 500 using the shared handler
        await handleApiError(response.status, () => updateCode(code, apptId, tryRefresh), tryRefresh);

    } catch (error) {
        console.error("updateCode error:", error);
        return false;
    }
};
